import { Link } from 'gatsby';
import React, { useEffect, useState } from 'react';
import NewsletterForm from '../NewsletterForm';

const SubscribePopup = () => {
  const [SubscribePopupIsOpen, setSubscribePopupIsOpen] = useState(false);

  const openSubscribePopup = () => {
    const popup = document.querySelector('#offer-popup');
    const popupInner = document.querySelector('.offer-popup__inner');
    const body = document.querySelector('body');
    body.classList.add('lock-mobile-scroll');
    popup.style.display = 'block';
    setTimeout(function () {
      popupInner.style.opacity = '100';
      popupInner.style.transform = 'translateX(0)';
    }, 100);
  };

  const closeSubscribePopup = () => {
    const popup = document.querySelector('#offer-popup');
    const popupInner = document.querySelector('.offer-popup__inner');
    const body = document.querySelector('body');
    body.classList.remove('lock-mobile-scroll');
    popupInner.style.opacity = '0';
    popupInner.style.transform = 'translateX(5%)';
    setTimeout(function () {
      popup.style.display = 'none';
    }, 400);

    localStorage.setItem('SubscribePopupShown', 'true');
  };

  useEffect(() => {
    const popupShown = localStorage.getItem('SubscribePopupShown');

    if (!popupShown) {
      const timeoutId = setTimeout(() => {
        setSubscribePopupIsOpen(true);
      }, 60000);

      return () => clearTimeout(timeoutId);
    }
  }, []);

  useEffect(() => {
    if (SubscribePopupIsOpen) {
      openSubscribePopup();
    }
  }, [SubscribePopupIsOpen]);

  return (
    <>
      <section
        id="offer-popup"
        className={`offer-popup fixed z-[9999999999999] bottom-[20px] mdscreen:bottom-0 right-[20px] -md:right-0 -md:bottom-0 w-[700px] mdscreen:w-[100%] -md:w-full -md:h-screen`}
        style={{ display: 'none' }}
      >
        <div className="smscreen:flex smscreen:flex-col offer-popup__inner flex -md:flex-col -md:justify-center -md:h-full -md:px-[20px] -md:py-[40px] bg-black/50 opacity-0 translate-x-[5%] transition-all ease-linear duration-300 md:rounded-[1em]">
          <button
            onClick={() => closeSubscribePopup()}
            className="offer-popup__close-btn absolute z-[9999999] top-[15px] right-[0px] hover:cursor-pointer md:block"
          >
            <div className="popup__close__icon icon-close">
              <div className="top burger-bar--light"></div>
              <div className="bot burger-bar--light"></div>
            </div>
          </button>
          <div className="offer-popup__img-wrapper w-1/3 mdscreen:hidden -md:w-full -md:h-[180px]">
            <img
              src="https://cms.entara.co.tz/wp-content/uploads/2025/03/Serengeti@HagaiZvulun00006-e1741892128698.webp"
              alt=""
              className="offer-popup__img h-full w-full object-cover object-left"
            />
          </div>
          <div className="offer-popup__content w-2/3 mdscreen:w-[96%] mdscreen:ml-[38px] -md:w-full -md:h-auto -md:max-h-full py-[40px] relative bg-grey-100 flex flex-col gap-[5px] items-start px-10 -md:px-7">
            <button
              onClick={() => closeSubscribePopup()}
              className="offer-popup__close-btn absolute top-[20px] right-[20px] hover:cursor-pointer -md:hidden"
            >
              <img
                src="https://cms.entara.co.tz/wp-content/uploads/2025/01/popup-close-white-icon.svg"
                alt="close-icon"
                className="offer-popup__close-btn__icon h-[20px] w-[20px] object-contain"
              />
            </button>
            <div className="popup-form">
              <h2 className="text-white-400 font-600 text-[16px] smscreen2:font-500 smscreen2:w-[94%] smscreen2:text-[16px] smscreen2:leading-[20px] leading-[30px] pl-5 pt-10 tracking-[1.6px] uppercase">
                Stay Connected to the Wild
              </h2>
            </div>
            <div className="content">
              <p className="text-[#fff] text-[10px] pl-5 pr-30 font-400 overflow-auto max-h-[160px] mdscreen:hidden">
                Join our Entara community and bring the magic of northern Tanzania straight to your inbox. Get exclusive updates on our new safari journeys, immersive cultural experiences, and unique stories from the heart of the Serengeti. Embrace the wild and discover moments crafted to inspire.
                Sign up today and be the first to experience Africa's untamed beauty.
              </p>
              <p className="text-[#fff] text-[10px] pl-5 pr-30 font-400 overflow-auto max-h-[160px] md:hidden">
                Sign up today and be the first to experience Africa's untamed beauty.
              </p>
            </div>
            <NewsletterForm />
          </div>
        </div>
      </section>
    </>
  );
};

export default SubscribePopup;